import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export type SkeletonLoaderProps = {
  width?: string
  height?: string
  count?: number
  circle?: boolean
}

export function SkeletonLoader(props: SkeletonLoaderProps) {
  const { width, height, count, circle } = props
  return (
    <Skeleton width={width} height={height} count={count} circle={circle} />
  )
}
